function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;
function pug_style(r){if(!r)return"";if("object"==typeof r){var t="";for(var e in r)pug_has_own_property.call(r,e)&&(t=t+e+":"+r[e]+";");return t}return r+""}function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Array, continueBtnText, dirs, doneText, game, grid, hasNarration, hasPrompt, i18n, prompt, size, submitUp, title, words) {
      if (game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled) {
pug_html = pug_html + "\u003Cdiv class=\"full-screen\"\u003E\u003Cdiv class=\"game-stepper text-lg text-bold\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"game-progress\"\u003E\u003Cdiv class=\"game-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"content content-fit clearfix\"\u003E\u003Cdiv class=\"text-center block-v-lg\"\u003E\u003Ch1 class=\"fade-in\"\u003E" + (null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003Cdiv class=\"grid-container block-md block-dk\"\u003E\u003Cdiv class=\"grid\"\u003E";
size = 1 / grid.length * 100;
dirs = ["up", "down", "left", "right"]
// iterate grid
;(function(){
  var $$obj = grid;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var row = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"grid-row clearfix\""+pug_attr("style", pug_style(`height: ${size}%;`), true, true)) + "\u003E";
// iterate row
;(function(){
  var $$obj = row;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var col = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-col","text-uppercase",`delay-${_.random(3)} slide-${_.sample(dirs)}`], [false,false,true]), false, true)+pug_attr("data-letter", col, true, true)+pug_attr("style", pug_style(`width: ${size}%;`), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = col) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var col = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-col","text-uppercase",`delay-${_.random(3)} slide-${_.sample(dirs)}`], [false,false,true]), false, true)+pug_attr("data-letter", col, true, true)+pug_attr("style", pug_style(`width: ${size}%;`), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = col) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var row = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv" + (" class=\"grid-row clearfix\""+pug_attr("style", pug_style(`height: ${size}%;`), true, true)) + "\u003E";
// iterate row
;(function(){
  var $$obj = row;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var col = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-col","text-uppercase",`delay-${_.random(3)} slide-${_.sample(dirs)}`], [false,false,true]), false, true)+pug_attr("data-letter", col, true, true)+pug_attr("style", pug_style(`width: ${size}%;`), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = col) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var col = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-col","text-uppercase",`delay-${_.random(3)} slide-${_.sample(dirs)}`], [false,false,true]), false, true)+pug_attr("data-letter", col, true, true)+pug_attr("style", pug_style(`width: ${size}%;`), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = col) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"grid-highlights\"\u003E";
// iterate (new Array(words.length + 1))
;(function(){
  var $$obj = (new Array(words.length + 1));
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var word = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-highlight",`grid-highlight-${i}`], [false,true]), false, true)+pug_attr("style", pug_style(`width: ${size}%; height: ${size}%;`), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var word = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["grid-highlight",`grid-highlight-${i}`], [false,true]), false, true)+pug_attr("style", pug_style(`width: ${size}%; height: ${size}%;`), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-footer","block-v-lg",submitUp ? "slide-footer--up slide-down" : "slide-up"], [false,false,true]), false, true)) + "\u003E";
if (hasPrompt) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-touched\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis\" id=\"done-btn\"\u003E" + (null == (pug_interp = doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (typeof prompt === "string") {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt text-uppercase text-bold\"\u003E\u003Cdiv class=\"slide-footer-prompt-content content-ver\" id=\"prompt\"\u003E" + (null == (pug_interp = prompt) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis content-ver\" id=\"prompt-btn\"\u003E" + (null == (pug_interp = continueBtnText || doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
if (hasNarration) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-narration\"\u003E\u003Cdiv class=\"narration-progress btn btn-muted\"\u003E\u003Cdiv class=\"narration-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wave-ellipse\"\u003E\u003Cspan class=\"bullet delay-1 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-2 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-3 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "Array" in locals_for_with ?
        locals_for_with.Array :
        typeof Array !== 'undefined' ? Array : undefined, "continueBtnText" in locals_for_with ?
        locals_for_with.continueBtnText :
        typeof continueBtnText !== 'undefined' ? continueBtnText : undefined, "dirs" in locals_for_with ?
        locals_for_with.dirs :
        typeof dirs !== 'undefined' ? dirs : undefined, "doneText" in locals_for_with ?
        locals_for_with.doneText :
        typeof doneText !== 'undefined' ? doneText : undefined, "game" in locals_for_with ?
        locals_for_with.game :
        typeof game !== 'undefined' ? game : undefined, "grid" in locals_for_with ?
        locals_for_with.grid :
        typeof grid !== 'undefined' ? grid : undefined, "hasNarration" in locals_for_with ?
        locals_for_with.hasNarration :
        typeof hasNarration !== 'undefined' ? hasNarration : undefined, "hasPrompt" in locals_for_with ?
        locals_for_with.hasPrompt :
        typeof hasPrompt !== 'undefined' ? hasPrompt : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "prompt" in locals_for_with ?
        locals_for_with.prompt :
        typeof prompt !== 'undefined' ? prompt : undefined, "size" in locals_for_with ?
        locals_for_with.size :
        typeof size !== 'undefined' ? size : undefined, "submitUp" in locals_for_with ?
        locals_for_with.submitUp :
        typeof submitUp !== 'undefined' ? submitUp : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "words" in locals_for_with ?
        locals_for_with.words :
        typeof words !== 'undefined' ? words : undefined));
    ;;return pug_html;};module.exports=template;